"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SentryNonRecordingSpan = void 0;

var _propagationContext = require("../utils-hoist/propagationContext.js");

var _spanUtils = require("../utils/spanUtils.js");

/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */
class SentryNonRecordingSpan {
  constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0, _propagationContext.generateTraceId)();
    this._spanId = spanContext.spanId || (0, _propagationContext.generateSpanId)();
  }
  /** @inheritdoc */


  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: _spanUtils.TRACE_FLAG_NONE
    };
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function


  end(_timestamp) {}
  /** @inheritdoc */


  setAttribute(_key, _value) {
    return this;
  }
  /** @inheritdoc */


  setAttributes(_values) {
    return this;
  }
  /** @inheritdoc */


  setStatus(_status) {
    return this;
  }
  /** @inheritdoc */


  updateName(_name) {
    return this;
  }
  /** @inheritdoc */


  isRecording() {
    return false;
  }
  /** @inheritdoc */


  addEvent(_name, _attributesOrStartTime, _startTime) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */


  addLink(_link) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */


  addLinks(_links) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */


  recordException(_exception, _time) {// noop
  }

}

exports.SentryNonRecordingSpan = SentryNonRecordingSpan;